function getSite() {
  const site = window.location.pathname.includes('business')
  return site ? 'site/business' : 'site/consumer'
}

export default getSite()
